module.exports = __webpack_public_path__ + "static/media/responsive.4aec4328.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/responsive.svg
// module id = 48
// module chunks = 0